import React from 'react';
import IndividualPerformanceCard from '../cardsSection/IndividualPerfomanceCard';
import { useSelector } from 'react-redux';
import { Grid, Skeleton } from '@mui/material';

export default function IndividualCardLanding() {
  const individualCards = useSelector((state) => state.pointTracker.individualCards.data);
  const individualCardsLoading = useSelector((state) => state.pointTracker.individualCards.loading);

  return (
    <Grid container spacing={2}>
      {individualCardsLoading
        ? Array.from({ length: 6 })?.map((_, i) => (
            <Grid item lg={4} key={i}>
              <Skeleton width={'100%'} height={300} />
            </Grid>
          ))
        : individualCards?.map((values, i) => (
            <Grid item lg={4} md={6} xs={12} key={i}>
              <IndividualPerformanceCard
                title={values?.squadName}
                data={values?.ogas || []}
                total={values?.totalRevenue}
              />
            </Grid>
          ))}
    </Grid>
  );
}
